// DS: C26
import React from 'react';
import cn from 'classnames';
import pick from 'lodash/pick';
import Tabs, { Props as TabsProps } from '../..';

import s from './SelfContainedTabs.scss';

export interface Props extends Omit<TabsProps, 'viewClassNames'> {
  updatedStyles?: boolean;
};

export const SelfContainedTabs: React.FC<Props> = ({ updatedStyles = true, ...props }) => {
  return (
    <Tabs {...props} viewClassNames={{
      root: cn(s['root'], updatedStyles && s['v2']),
      ...pick(s, 'tab', 'active-tab')
    }} />
  );
};
SelfContainedTabs.displayName = 'SelfContainedTabs';

export default SelfContainedTabs;
